<template>
  <div class="center-echarts">
    <div ref="main" class="echarts"></div>
    <div class="middle-content" v-if="echartsData.length > 0">
      <p>{{getNum}}</p>
      <div>企业总数</div>
    </div>
    <div v-else class="no-data">暂无产业分布信息</div>
  </div>
</template>

<script>
import * as echarts from "echarts"
export default {
  props: {
    coTypeNumMap: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    getNum () {
      return this.echartsData.reduce((total, item) => total + item.value, 0)
    }
  },
  data() {
    return {
      myChart: null,
      colors: ["#1890FF", "#1EC4C8", "#267ECC", "#A0DEFF", "#FFCC79"],
      echartsData: [],
      legendData: []
    }
  },
  methods: {
    drawChart() {
      this.myChart && this.myChart.dispose()
      if (!this.echartsData || this.echartsData.length === 0) return
      this.myChart = echarts.init(this.$refs.main)
      // let sum = this.echartsData.reduce((total, item) => total + item.value, 0)
      const option = {
        // title: [
        //   {
        //     text: `{val|${sum}}\n{name|总金额}`,
        //     top: 'center',
        //     left: '22%',
        //     textStyle: {
        //       rich: {
        //         name: {
        //           fontSize: this.$remToPx(0.2),
        //           fontWeight: 500,
        //           color: '#FFFFFF',
        //         },
        //         val: {
        //           fontSize: this.$remToPx(0.4),
        //           fontWeight: 600,
        //           color: '#FFFFFF'
        //         },
        //       }
        //     }
        //   }
        // ],
        legend: {
          orient: 'vertical',
          type: 'scroll', // 显示分页
          data: this.legendData, // 显示分页要加
          selectedMode: false, // 关闭图例的选择模式  
          right: '5%',
          top: '10%',
          pageIconInactiveColor: '#267ECC',
          pageIconSize: this.$remToPx(0.18),
          pageIconColor: '#8CD8FF',
          pageTextStyle: {
            color: '#E9F5FF',
            fontSize: this.$remToPx(0.18)
          },
          textStyle: {
            color: '#FFFFFF',
            fontSize: this.$remToPx(0.14),
            'margin-bottom': this.$remToPx(0.18)
          },
          itemWidth: this.$remToPx(0.08),
          itemHeight: this.$remToPx(0.08),
          // itemGap: 8
        },
        series: [
          // {
          //   name: "外边框",
          //   type: "pie",
          //   hoverAnimation: false,
          //   center: ['30%', '50%'],
          //   radius: ["50%", "75%"],
          //   minAngle: 10,
          //   label: {
          //     normal: {
          //       show: false,
          //     },
          //   },
          //   itemStyle: {
          //     color: '#37495B',
          //     opacity: 0.5
          //   },
          //   data: [1]
          // },
          {
            name: "",
            type: "pie",
            hoverAnimation: false,
            center: ['30%', '50%'],
            radius: ["70%", "85%"],
            minAngle: 10,
            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              color: (params) => this.colors[params.dataIndex] || '#3e44ec'
            },
            data: this.echartsData
          },
        ]
      }
      this.myChart.setOption(option)
    }
  },
  watch: {
    coTypeNumMap(val) {
      let echartsData = []
      let legendData = []
      for (const key in val) {
        legendData.push(key)
        echartsData.push({
          name: key,
          value: val[key]
        })
      }
      this.echartsData = [].concat(echartsData)
      this.legendData = [].concat(legendData)
      this.drawChart()
    }
  },
  beforeDestroy () {
    this.myChart && this.myChart.dispose()
    this.myChart = null
  }
}
</script>

<style lang="scss" scoped>
.center-echarts {
  // position: relative;
  // height: 100%;
  // width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .echarts {
    height: 100%;
    width: 100%;
  }
  .middle-content {
    position: absolute;
    left: 0.9rem;
    top: 0.98rem;
    width:1rem;
    text-align: center;
    div {
      font-size: 0.15rem;
      color: #fff;
    }
    p {
      font-size: 0.25rem;
      color: #fff;
    }
  }
  .no-data {
    position: absolute;
    left: 0;
    top: 0.8rem;
    right: 0;
    font-size: 0.2rem;
    color: #fff;
    text-align: center;
    margin: auto;
  }
}
</style>